// extracted by mini-css-extract-plugin
module.exports = {"element":"Forms_element__3Ktu0","label":"Forms_label__9aoLd","input":"Forms_input__34n01","select":"Forms_select__32bDl"};